module.exports = __webpack_public_path__ + "static/media/solution3.04d35ab8.png";